import type { PageProps } from 'gatsby';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import AlertTable from '@components/Tables/AlertTable';

import { useListAlerts } from '@hooks/api/alerts/alert';

import MainWrapper from '@views/Records/Common/MainWrapper';

const messages = defineMessages({
  title: {
    id: 'alertsMain.title',
    defaultMessage: 'Alerts',
  },
});

export default function AlertsPage({ params }: PageProps) {
  const { formatMessage } = useIntl();

  const { data, loading } = useListAlerts(); // Culprit

  return (
    <MainWrapper
      friendlyName={formatMessage(messages.title)}
      loading={loading}
      title={formatMessage(messages.title)}
    >
      <AlertTable {...params} data={data?.listAlerts ?? []} />
    </MainWrapper>
  );
}
